/**
 * Random id tying one run of a funnel's events together (a wizard opened, a
 * cut sheet filled in). Shared by the modal renderers and the web app's own
 * flows so every `flow_id` has the same shape.
 * @returns A UUID, or a time+random fallback where `crypto.randomUUID` is missing
 */
export function newFlowId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
